// extracted by mini-css-extract-plugin
export default {"notificationWidget":"notifications_mobile_notificationWidget__Zc-ra","notificationList":"notifications_mobile_notificationList__OO74b"};